import {Grid} from '@mantine/core';
import React from 'react';

import {Grid as GridType} from './DataLayoutTypes';
import GridBlock from './GridBlock';

interface GridSectionProps {
  grid: GridType;
  layoutPath: Array<string | number>;
}

/** @package */
export default function GridSection({grid, layoutPath}: GridSectionProps): JSX.Element {
  return (
    <Grid>
      {grid.rows
        .map((row, rowIndex) =>
          row.map((block, columnIndex) => (
            <Grid.Col span={12 / row.length} key={`block-${rowIndex}-${columnIndex}`}>
              <GridBlock
                block={block}
                key={`block-${rowIndex}-${columnIndex}`}
                layoutPath={[...layoutPath, 'grid', 'rows', rowIndex, columnIndex]}
              />
            </Grid.Col>
          ))
        )
        .flat()}
    </Grid>
  );
}
